// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { Language } from "../schema";

export function serialize_Language(obj: Language): string {
  const serialized = ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"): unknown => {
    return value;
  })(obj);
  return renderJsonWithNumbersAsBigint(serialized);
}
export function deserialize_Language(str: string): ParserResult<Language> {
  return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "en":
        return { success: true, value: "en" };
      case "de":
        return { success: true, value: "de" };
      case "es":
        return { success: true, value: "es" };
      case "ru":
        return { success: true, value: "ru" };
      case "zh":
        return { success: true, value: "zh" };
      case "pt":
        return { success: true, value: "pt" };
      case "fr":
        return { success: true, value: "fr" };
      default:
        return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr'.` };
    }
  })(parseJsonWithNumbersAsBigint(str));
}
